import React, { createContext, useState, useCallback, useMemo } from 'react';

export const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const [config, setConfig] = useState({
    position: 'topRight',
    duration: 3000,
    maxToasts: 10,
  });

  const removeToast = useCallback((id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  const show = useCallback(({ title, description, color = 'primary', duration }) => {
    const id = `toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const toastDuration = duration ?? config.duration;

    setToasts((prevToasts) => {
      const newToasts = [...prevToasts, { id, title, description, color, duration: toastDuration }];
      if (newToasts.length > config.maxToasts) {
        return newToasts.slice(1);
      }
      return newToasts;
    });

    return id;
  }, [config.duration, config.maxToasts]);

  const updateConfig = useCallback((newConfig) => {
    setConfig((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);

  const value = useMemo(() => ({
    show,
    remove: removeToast,
    config,
    updateConfig,
    toasts,
  }), [show, removeToast, config, toasts]);

  return (
    <ToastContext.Provider value={value}>
      {children}
    </ToastContext.Provider>
  );
};
